module.exports = __webpack_public_path__ + "6cc5b1654c1522959e86ebcfc35a9abb.jpg";